import {
  getEventTypeList,
  postEventType,
  updateEventType,
  deleteEventType,
} from "@/services/event-type.service";

// initial state
const state = () => ({
  eventTypeModel: {},
});

// mutations
const mutations = {
  setEventTypeModel(state, data) {
    state.eventTypeModel = data;
  },
};

// actions
const actions = {
  //Etkinlik Listesi
  async loadEventTypeList(vuexContext, co) {
    return await getEventTypeList(co).then((response) => {
      let data = response.data.data.items;

      data.map((item, index) => {
        item.index = index + 1;
      });
      return data;
    });
  },

  async postEventType(vuexContext, data) {
    return await postEventType(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateEventType(vuexContext, data) {
    return await updateEventType(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteEventType(vuexContext, eventCategoryId) {
    return await deleteEventType(eventCategoryId).then((response) => {
      let data = response;
      return data;
    });
  },

  addEventTypeModel(vuexContext, data) {
    vuexContext.commit("setEventTypeModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
